import React, { useMemo } from 'react';
import { Modal, Button, message } from '@common/musicHubCommon';
import './ShareSongDialog.scss';

export interface ShareSongDialogProps {
  open: boolean;
  onClose: () => void;
  songTitle: string;
  artistName: string;
  musicId: string;
}

/** 与线上乐页一致：https://music.phoenix-browser.com/music/{musicID} */
const SHARE_MUSIC_PAGE_ORIGIN = 'https://music.phoenix-browser.com';

function buildShareUrl(musicId: string): string {
  const id = (musicId || '').trim();
  const seg = id ? encodeURIComponent(id) : '';
  return `${SHARE_MUSIC_PAGE_ORIGIN}/music/${seg}`;
}

function buildSharePlainText(title: string, artist: string, musicId: string): string {
  const url = buildShareUrl(musicId);
  return `Listen to ${title} by ${artist} on Phoenix Music. ${url}`;
}

export const ShareSongDialog: React.FC<ShareSongDialogProps> = ({
  open,
  onClose,
  songTitle,
  artistName,
  musicId,
}) => {
  const url = useMemo(() => buildShareUrl(musicId), [musicId]);
  const plainText = useMemo(
    () => buildSharePlainText(songTitle, artistName, musicId),
    [songTitle, artistName, musicId],
  );

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(plainText);
      message.success('Link copied');
      onClose();
    } catch {
      message.error('Copy failed');
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={448}
      centered
      className="share-song-dialog__modal"
      wrapClassName="share-song-dialog__modalWrap"
      title={<span className="share-song-dialog__title">Share</span>}
      closable
    >
      <div className="share-song-dialog__body">
        <div className="share-song-dialog__inputBox">
          <p className="share-song-dialog__previewText">
            Listen to {songTitle} by {artistName} on Phoenix Music.{' '}
            <span className="share-song-dialog__previewUrl">{url}</span>
          </p>
        </div>
        <div className="share-song-dialog__actions">
          <Button className="share-song-dialog__btnCancel" onClick={onClose}>
            Cancel
          </Button>
          <Button type="primary" className="share-song-dialog__btnPrimary" onClick={handleCopy}>
            Copy link
          </Button>
        </div>
      </div>
    </Modal>
  );
};
